"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _colors = _interopRequireDefault(require("../../colors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var drawerWidthOpen = 240;
var drawerWidthClosed = 64;
var topbarHeight = 64;
var navItemHeight = 48;
var padding = 20;

var styles = function styles(theme) {
  return {
    sidebar: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      backgroundColor: _colors["default"].purple,
      color: _colors["default"].white
    },
    open: {
      width: drawerWidthOpen,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    closed: {
      width: drawerWidthClosed,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      overflowX: 'hidden'
    },
    heading: {
      backgroundColor: _colors["default"].purpleDark,
      paddingLeft: padding,
      height: topbarHeight,
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer'
    },
    sidebarContent: {
      paddingTop: padding,
      paddingBottom: padding
    },
    icon: {
      paddingRight: padding
    },
    navItem: {
      height: navItemHeight,
      paddingLeft: padding,
      paddingRight: padding,
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
      textDecoration: 'none'
    },
    active: {
      backgroundColor: _colors["default"].purpleHover,
      borderLeft: "3px solid ".concat(_colors["default"].pink),
      paddingLeft: padding - 3
    },
    badge: {
      marginLeft: 'auto'
    }
  };
};

exports.styles = styles;